import { cn } from "@/lib/cn";

/**
 * Sticky scope bar pinned to the top of the page scroll. Deliberately neutral —
 * the accent is reserved for the open panel's marker and the controls.
 */
export const SCOPE_BAR_CLASS =
  "sticky top-0 z-20 border-b border-bridge-border bg-white px-5 py-3";

/** Sticky action bar docked to the bottom of the page scroll. */
export function actionBarClass(dirty: boolean) {
  return cn(
    "sticky bottom-0 z-20 flex items-center gap-2 rounded-b-xl border-t bg-white px-5 py-3 transition-colors",
    dirty ? "border-t-bridge-warning/70" : "border-bridge-border",
  );
}
